export const OFFER_PARTNER_MONTHLY_OBLIGATIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerMonthlyObligationsUpdated";
